import React, { useMemo } from 'react';

// Decorative parallax star-field for dark sections.
// Moves with scroll via the global --cea-scroll CSS variable (set in App).
export const Stars = ({ count = 36, seed = 1 }) => {
  const stars = useMemo(() => {
    const rng = (n) => {
      // simple deterministic pseudo-random based on seed + index
      const x = Math.sin(seed * 999 + n * 137.13) * 10000;
      return x - Math.floor(x);
    };
    return Array.from({ length: count }, (_, i) => {
      const size = 1 + Math.round(rng(i) * 2.2);
      return {
        id: `star-${seed}-${i}`,
        left: `${(rng(i + 1) * 100).toFixed(2)}%`,
        top: `${(rng(i + 2) * 100).toFixed(2)}%`,
        size: `${size}px`,
        tw: `${(3 + rng(i + 3) * 4).toFixed(2)}s`,
        delay: `${(rng(i + 4) * 4).toFixed(2)}s`,
      };
    });
  }, [count, seed]);

  return (
    <div className="stars" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{ left: s.left, top: s.top, width: s.size, height: s.size, '--tw': s.tw, animationDelay: s.delay }}
        />
      ))}
    </div>
  );
};
